<!--begin: My Cart -->
<div  ngbDropdown placement="bottom" autoClose="outside" class="kt-header__topbar-item">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<span class="kt-header__topbar-icon"
			[ngClass]="{'kt-header__topbar-icon--brand':  iconType === 'brand'}">
			<i *ngIf="!useSVG" [ngClass]="icon"></i>
			<span *ngIf="useSVG"
				class="kt-svg-icon"
				[inlineSVG]="icon"
				[ngClass]="{'kt-svg-icon--brand':  iconType === 'brand'}"></span>

				<!-- Badge, sepetteki urun sayisi 0 dan buyukse gorunur -->
				<span *ngIf="badgeValue > 0" class="kt-badge kt-badge--warning"><strong>{{badgeValue}}</strong></span>
		</span>
	</div>

		<!-- Sepet ikonuna basilinca acilan menu, sepettki urun adedi > 0 ise gorunur -->
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
		<form>
			<!-- begin:: Mycart -->
			<div class="kt-mycart">
				<div class="kt-mycart__head kt-head" [ngStyle]="{'background-image': 'url('+bgImage+')'}">
					<div class="kt-mycart__info">
						<span class="kt-mycart__icon"><i class="flaticon2-shopping-cart-1 kt-font-success"></i></span>
						<h3 class="kt-mycart__title">{{'CART.MYCART' | localize}}</h3>
					</div>
					<div class="kt-mycart__button">
						<button type="button" class="btn btn-success btn-sm">{{cartService.productCount$ | async}} {{'CART.PRODUCT' | localize}}</button>
					</div>
				</div>

				 <div [perfectScrollbar]="{wheelPropagation: false}" [ngStyle]="{'max-height': '28vh', 'position': 'relative'}" class="kt-mycart__body">
					<div *ngFor="let product of cartService.products$ | async" class="kt-mycart__item">
						<div class="kt-mycart__container">
							<div class="kt-mycart__info">
								
								<span class="kt-mycart__desc">
			                        #{{product.kod}}
			                    </span>
								<a href="javascript:;" class="kt-mycart__title">
									{{product.name}}
								</a>

								<!-- <div class="kt-mycart__action">
									<span class="kt-mycart__price">$ 450</span>
									<span class="kt-mycart__text">for</span>
									<span class="kt-mycart__quantity">7</span>
									<a href="javascript:;" class="btn btn-label-success btn-icon">−</a>
									<a href="javascript:;" class="btn btn-label-success btn-icon">+</a>
								</div> -->
								
									
								
							</div>

							<a href="javascript:;" class="kt-mycart__pic">
								<img [attr.src]="getPhotoUrl(product.kod)" title="">
							</a>
						</div>
					</div>

				
				</div> 

				

				<div class="kt-mycart__footer">
					<div *ngIf="(cartService.productCount$ | async) == 0" class="kt-mycart__section">
						<div class="kt-mycart__subtitel">
							<span>{{'CART.EMPTY.MESSAGE' | localize}}</span>
							
						</div>

					
					</div>
					<div *ngIf="(cartService.productCount$ | async) > 0" class="kt-mycart__button kt-align-right">
						<button type="button" (click)="gotoCartPage()" class="btn btn-primary btn-sm">{{'CART.GOTO.CART' | localize}}</button>
					</div>
				</div>
			</div>
			<!-- end:: Mycart -->
		</form>
	</div>
</div>
<!--end: My Cart -->
